import { GridLoadResponse } from './load-grid-resource.model';

export enum LoadProductsGridRequestKeys {
  loadOptions = 'loadOptions',
}

export interface LoadProductsGridRequest {
  [LoadProductsGridRequestKeys.loadOptions]?: Record<string, unknown>;
}

export type LoadProductsGridResponse = GridLoadResponse;
